/* WS-BLOG: article + listing behaviour. Vanilla, deferred, no dependencies.
   - TOC: reconciles the server-built list with the real H2s (ids, dead entries), scroll-spy, mobile sticky bar + dropdown
   - reading progress fallback (only when plentum-motion.js is not on the page; the motion script drives [data-pm-progress] otherwise)
   - share / copy link, "was this helpful", tabs fallback (only when plentum-motion.js is absent) */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasMotion = !!d.querySelector('script[src*="plentum-motion"]');
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function raf(fn) { var t = 0; return function () { if (!t) t = w.requestAnimationFrame(function () { t = 0; fn(); }); }; }

  function init() {
    var root = $('.blg-article');
    if (root) {
      var hdr = $('.page-header');
      var setTop = function () { var h = hdr ? hdr.offsetHeight : 0; if (h > 20 && h < 160) root.style.setProperty('--blg-top', h + 'px'); };
      setTop(); w.addEventListener('resize', setTop);

      /* reading progress fallback */
      var bar = $('.blg-progress');
      var wrap = $('.blg-body-wrap');
      if (bar && wrap && !hasMotion) {
        var upd = raf(function () {
          var r = wrap.getBoundingClientRect(), h = r.height - w.innerHeight, y = -r.top;
          bar.style.setProperty('--pm-progress', Math.max(0, Math.min(1, h > 0 ? y / h : 0)).toFixed(4));
        });
        w.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
      }

      /* TOC */
      var toc = $('[data-blg-toc]', root);
      var heads = $$('.blg-body .article-content h2', root);
      if (toc) {
        var links = $$('.blg-toc__link', toc), used = [], pairs = [];
        links.forEach(function (a) {
          var key = norm(a.getAttribute('data-blg-text')), hit = null, i;
          for (i = 0; i < heads.length; i++) { if (used.indexOf(i) < 0 && norm(heads[i].textContent) === key) { hit = i; break; } }
          if (hit === null) { for (i = 0; i < heads.length; i++) { var t = norm(heads[i].textContent); if (used.indexOf(i) < 0 && t && (t.indexOf(key) === 0 || key.indexOf(t) === 0)) { hit = i; break; } } }
          if (hit === null) { var li = a.closest('li'); if (li) li.parentNode.removeChild(li); return; }
          used.push(hit);
          var h = heads[hit], id = h.id || (a.getAttribute('href') || '').slice(1);
          if (!h.id) h.id = id;
          a.setAttribute('href', '#' + h.id);
          pairs.push({ a: a, h: h });
        });
        if (pairs.length < 3) { var rail = toc.parentNode; toc.parentNode.removeChild(toc); }
        else {
          var now = $('[data-blg-toc-now]', toc), btn = $('[data-blg-toc-toggle]', toc), active = -1;
          var close = function () { toc.removeAttribute('data-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); };
          if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); var o = toc.hasAttribute('data-open'); if (o) close(); else { toc.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); } });
          d.addEventListener('click', function (e) { if (!toc.contains(e.target)) close(); });
          d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
          pairs.forEach(function (p) {
            p.a.addEventListener('click', function (e) {
              e.preventDefault(); close();
              p.h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
              if (w.history && w.history.replaceState) w.history.replaceState(null, '', '#' + p.h.id);
              p.h.setAttribute('tabindex', '-1'); p.h.focus({ preventScroll: true });
            });
          });
          var spy = raf(function () {
            var top = (parseInt(getComputedStyle(root).getPropertyValue('--blg-top'), 10) || 76) + 96, cur = -1, i;
            for (i = 0; i < pairs.length; i++) { if (pairs[i].h.getBoundingClientRect().top <= top) cur = i; else break; }
            if (cur === active) return;
            active = cur;
            pairs.forEach(function (p, j) { var on = j === cur; p.a.classList.toggle('is-active', on); if (on) p.a.setAttribute('aria-current', 'location'); else p.a.removeAttribute('aria-current'); });
            if (now) now.textContent = cur >= 0 ? pairs[cur].a.textContent : '';
          });
          w.addEventListener('scroll', spy, { passive: true }); w.addEventListener('resize', spy); spy();
        }
      }

      /* share + copy */
      var share = $('[data-blg-share]', root), copy = $('[data-blg-copy]', root), st = $('.blg-share__status', root);
      var say = function (m) { if (!st) return; st.textContent = m; w.setTimeout(function () { st.textContent = ''; }, 2200); };
      var url = (w.location.origin + w.location.pathname);
      if (share && navigator.share) { share.hidden = false; share.addEventListener('click', function () { navigator.share({ title: d.title, url: url }).catch(function () {}); }); }
      if (copy) copy.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, function () { say('Copy failed'); });
        else { var ta = d.createElement('textarea'); ta.value = url; d.body.appendChild(ta); ta.select(); try { d.execCommand('copy'); say('Link copied'); } catch (e) { say('Copy failed'); } d.body.removeChild(ta); }
      });


      /* sticky formula / quiz bar (below 1100px, where the rail card is hidden): appears after 50% of the article, hides near the end CTA, dismissible.
         T-FUNNEL21: the dismissal is remembered in localStorage for 14 days (sessionStorage kept for the exit-intent check in fnl-funnel.js). */
      var sbar = $('[data-blg-bar]', root);
      if (sbar && wrap) {
        var closed = false, SK = 'blg_bar_closed', LK = 'pl_fnl_bar_closed', DAYS14 = 12096e5;
        try { closed = w.sessionStorage.getItem(SK) === '1'; } catch (e) {}
        try { var lt = +w.localStorage.getItem(LK); if (lt && Date.now() - lt < DAYS14) closed = true; } catch (e) {}
        if (!closed) {
          var shown = false, gone = false;
          var hideBar = function () { sbar.classList.remove('is-on'); w.setTimeout(function () { sbar.hidden = true; }, 300); };
          var closeBar = function () { gone = true; try { w.sessionStorage.setItem(SK, '1'); } catch (e) {} try { w.localStorage.setItem(LK, String(Date.now())); } catch (e) {} hideBar(); };
          var chk = raf(function () {
            if (gone) return;
            var r = wrap.getBoundingClientRect(), total = r.height - w.innerHeight, pct = total > 0 ? (-r.top) / total : 0;
            var endCta = $('.blg-cta'), nearEnd = endCta && endCta.getBoundingClientRect().top < w.innerHeight;
            if (!shown && pct >= 0.50 && !nearEnd) {
              shown = true; sbar.hidden = false;
              w.requestAnimationFrame(function () { sbar.classList.add('is-on'); });
            } else if (shown && nearEnd) { shown = false; hideBar(); }
          });
          w.addEventListener('scroll', chk, { passive: true }); w.addEventListener('resize', chk);
          var cb = $('[data-blg-bar-close]', sbar); if (cb) cb.addEventListener('click', closeBar);
        }
      }

      /* GA4 select_promotion for blog formula CTAs (replaces internal UTM parameters) */
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-pl-cta]'); if (!a) return;
        var slot = a.getAttribute('data-pl-cta'), f = a.getAttribute('data-blg-formula') || '';
        try {
          var ev = { promotion_id: 'blog_' + slot, promotion_name: 'Blog formula CTA', creative_name: f, creative_slot: slot, location_id: (w.location.pathname || '') };
          if (typeof w.gtag === 'function') w.gtag('event', 'select_promotion', ev);
          (w.dataLayer = w.dataLayer || []).push({ event: 'select_promotion', ecommerce: ev });
        } catch (err) {}
      }, true);

      /* helpful */
      var hp = $('[data-blg-helpful]', root);
      if (hp) $$('[data-blg-vote]', hp).forEach(function (b) {
        b.addEventListener('click', function () {
          try { if (w.umami && typeof w.umami.track === 'function') w.umami.track('article_helpful', { article_handle: hp.getAttribute('data-article') || '', vote: b.getAttribute('data-blg-vote') }); } catch (e) {}
          hp.setAttribute('data-done', ''); var t = $('.blg-helpful__thanks', hp); if (t) t.hidden = false;
        });
      });
    }


    /* ---------- bridge card (J-B1) + plan-aware end CTA / bar (J-B2). Shared state: localStorage plentum_plan_v1 + event plentum:plan (research/19 §3.1) ---------- */
    (function () {
      var el = $('#blg-plan-data'), data = null;
      try { data = el ? JSON.parse(el.textContent) : null; } catch (e) {}
      if (!data) return;
      var PK = 'plentum_plan_v1', BANDS = ['u20', '21-25', '26-50', '51-75', 'o75'], BL = ['Under 20 lb', '20–25 lb', '26–50 lb', '51–75 lb', 'Over 75 lb'];
      var MAP_NEW = [0, 0, 1, 2, 3], MAP_HERO = [0, 1, 1, 2, 2];
      function read() { try { var p = JSON.parse(w.localStorage.getItem(PK)); return p && p.v === 1 ? p : null; } catch (e) { return null; } }
      function write(p) { try { w.localStorage.setItem(PK, JSON.stringify(p)); } catch (e) {} try { w.dispatchEvent(new CustomEvent('plentum:plan', { detail: p })); } catch (e) {} }
      function money(c) { return '$' + (Math.floor((c + 15) / 30) / 100).toFixed(2); }
      function calc(concern, band) {
        var c = data[concern], bi = BANDS.indexOf(band); if (!c || bi < 0) return null;
        var vi = Math.min((concern === 'daily' ? MAP_HERO : MAP_NEW)[bi], c.v.length - 1), v = c.v[vi];
        return { c: c, v: v, sach: vi + 1, label: BL[bi], url: c.u + '?variant=' + v.id, one: money(v.p), sub: v.s > 0 ? money(v.s) : null };
      }
      function mk(tag, cls, txt) { var n = d.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
      function dose(r) { return r.label + ' dog · ' + r.sach + ' sachet' + (r.sach > 1 ? 's' : '') + ' a day · 30-day box'; }
      var route = $('[data-blg-editorial-formula]');
      var editorialFormula = route ? route.getAttribute('data-blg-editorial-formula') : '';
      var plan = read();
      if (editorialFormula && plan && (!data[plan.concern] || data[plan.concern].f !== editorialFormula)) plan = null;
      var pname = plan && plan.name ? plan.name : null;

      var br = $('[data-blg-bridge]');
      if (br) {
        var ask = $('[data-blg-ask]', br), res = $('[data-blg-result]', br), concern = br.getAttribute('data-concern');
        var show = function (r, p) {
          res.textContent = '';
          res.appendChild(mk('p', 'blg-bridge__eyebrow', p && p.name ? p.name + '’s plan' : 'Your dog’s plan'));
          res.appendChild(mk('p', 'blg-bridge__formula', r.c.n));
          res.appendChild(mk('p', 'blg-bridge__dose', dose(r)));
          var pr = mk('div', 'blg-bridge__prices');
          var a = mk('div', 'blg-bridge__price'); a.appendChild(mk('span', null, 'One-time')); a.appendChild(mk('strong', null, r.one + '/day')); pr.appendChild(a);
          if (r.sub) { var b = mk('div', 'blg-bridge__price'); b.appendChild(mk('span', null, 'Subscribe')); b.appendChild(mk('strong', null, r.sub + '/day')); pr.appendChild(b); }
          res.appendChild(pr);
          var go = mk('a', 'blg-bridge__go', (p && p.step >= 2 && p.src ? 'Continue to ' : 'See ') + r.c.n);
          go.href = r.url; go.setAttribute('data-pl-cta', 'bridge_cta'); go.setAttribute('data-blg-formula', r.c.f); res.appendChild(go);
          var ch = mk('button', 'blg-bridge__change', 'Change size'); ch.type = 'button';
          ch.addEventListener('click', function () { res.hidden = true; ask.hidden = false; }); res.appendChild(ch);
          res.appendChild(mk('p', 'blg-bridge__note', r.c.note));
          ask.hidden = true; res.hidden = false;
        };
        $$('.blg-band', br).forEach(function (b) {
          b.addEventListener('click', function () {
            var cur = read();
            if (editorialFormula && cur && (!data[cur.concern] || data[cur.concern].f !== editorialFormula)) cur = null;
            var cc = cur && data[cur.concern] ? cur.concern : concern, band = b.getAttribute('data-band'), r = calc(cc, band); if (!r) return;
            var now = Date.now(), np = { v: 1, concern: cc, band: band, formula: r.c.u.split('/').pop(), name: cur ? cur.name : null, src: 'blog', step: 2, created: cur ? cur.created : now, updated: now };
            write(np); plan = np; show(r, np);
            try { var ev = { promotion_id: 'blog_bridge_band', creative_name: r.c.f, creative_slot: 'bridge_band', location_id: w.location.pathname }; if (typeof w.gtag === 'function') w.gtag('event', 'select_promotion', ev); (w.dataLayer = w.dataLayer || []).push({ event: 'select_promotion', ecommerce: ev }); } catch (e) {}
          });
        });
        if (plan && data[plan.concern] && calc(plan.concern, plan.band)) show(calc(plan.concern, plan.band), plan);
      }

      /* plan-aware end CTA and sticky bar */
      if (plan && data[plan.concern]) {
        var r2 = calc(plan.concern, plan.band);
        if (r2) {
          var cta = $('.blg-cta');
          if (cta) {
            var set = function (s, t) { var n = $(s, cta); if (n) n.textContent = t; };
            set('.blg-cta__eyebrow', 'Advanced K9 ' + r2.c.n);
            set('.blg-cta__title', (pname ? pname + '’s plan: ' : 'Your dog’s plan: ') + r2.c.n + '.');
            set('.blg-cta__sub', dose(r2) + ' · ' + r2.one + '/day one-time' + (r2.sub ? ', ' + r2.sub + '/day with Subscribe' : '') + '.');
            set('.blg-cta__price', 'Size picked for you');
            set('.blg-cta__note', r2.c.note);
            var bt = $('.blg-cta__btn', cta); if (bt) { bt.href = r2.url; bt.setAttribute('data-blg-formula', r2.c.f); bt.firstChild.nodeValue = 'Continue to ' + r2.c.n; }
            var ar = $('.blg-cta__art img', cta); if (ar && r2.c.img) { ar.src = r2.c.img; ar.removeAttribute('srcset'); }
            var qz = $('.blg-cta__quiz', cta); if (qz) qz.style.display = 'none';
          }
          var bar = $('[data-blg-bar]');
          if (bar) {
            var bl = $('.blg-bar__link', bar); if (bl) { bl.href = r2.url; bl.setAttribute('data-blg-formula', r2.c.f); }
            var be = $('.blg-bar__eyebrow', bar); if (be) be.textContent = pname ? pname + '’s plan' : 'Your dog’s plan';
            var bn = $('.blg-bar__name', bar); if (bn) { bn.textContent = ''; var st = d.createElement('strong'); st.textContent = r2.c.n; bn.appendChild(st); bn.appendChild(d.createTextNode(' · ' + r2.one + '/day')); }
            var bb = $('.blg-bar__btn', bar); if (bb) bb.textContent = 'Continue';
          }
        }
      }
    })();

    /* tabs fallback (listing) when the motion script is not loaded */
    if (!hasMotion) $$('[data-pm-tabs]').forEach(function (box) {
      var tb = $$('[data-pm-tab]', box), pn = $$('[data-pm-panel]', box);
      if (!tb.length) return;
      function pick(i) { tb.forEach(function (t, j) { var on = i === j; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; t.classList.toggle('is-active', on); var k = t.getAttribute('data-pm-tab'), p = pn.filter(function (x) { return x.getAttribute('data-pm-panel') === k; })[0] || pn[j]; if (p) p.hidden = !on; }); }
      tb.forEach(function (t, i) { t.addEventListener('click', function () { pick(i); }); t.addEventListener('keydown', function (e) { var n = tb.length, to = -1; if (e.key === 'ArrowRight') to = (i + 1) % n; else if (e.key === 'ArrowLeft') to = (i + n - 1) % n; if (to > -1) { e.preventDefault(); pick(to); tb[to].focus(); } }); });
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* T-TABLES (2026-10-13): a table frame that scrolls sideways (phones, wide tables) gets keyboard focus and a name,
   so Tab + arrow keys can scroll it (Safari does not make overflow frames focusable). Frames come from custom.js. */
(function () {
  'use strict';
  var d = document, w = window, raf = 0;
  function mark() {
    raf = 0;
    Array.prototype.forEach.call(d.querySelectorAll('.blg-body .plentum-table-scroll'), function (f) {
      var scrolls = f.scrollWidth - f.clientWidth > 1;
      if (scrolls && !f.hasAttribute('tabindex')) {
        var cap = f.querySelector('caption');
        f.setAttribute('tabindex', '0');
        f.setAttribute('role', 'region');
        var h = null, n = f.closest('.blg-table-wrap') || f;
        while (n && !h) { var prev = n.previousElementSibling; while (prev && !/^H[2-4]$/.test(prev.tagName)) prev = prev.previousElementSibling; h = prev; n = h ? null : n.parentElement; if (n && n.classList.contains('blg-body')) n = null; }
        f.setAttribute('aria-label', (cap && cap.textContent.trim()) || (h && h.textContent.trim() + ' (table)') || 'Table');
        f.setAttribute('data-blg-tbl-focus', '');
      } else if (!scrolls && f.hasAttribute('data-blg-tbl-focus')) {
        f.removeAttribute('tabindex'); f.removeAttribute('role'); f.removeAttribute('aria-label'); f.removeAttribute('data-blg-tbl-focus');
      }
    });
  }
  function soon() { if (!raf) raf = w.requestAnimationFrame(mark); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', soon); else soon();
  w.addEventListener('load', soon);
  w.addEventListener('resize', soon);
})();
